export const BALANCES_QUERY_KEY = "vacations/balances";
export const COLLABORATOR_ACCRUALS_QUERY_KEY =
  "vacations/collaborator-accruals";
